import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from './app/providers';
import { router } from './app/router';
import './styles/globals.css';
import './styles/patterns.css';
// Registers the smart guide's «پیشنهادها» hub section at import time.
import './features/guide/register';
import './features/integrations/register';

// The document is Persian and right-to-left before React renders anything. It
// is also declared statically in index.html; this is the belt to that braces,
// for the case where the shell is served by something that rewrote the tag.
//
// The THEME is not set here: `@bookora/ui`'s `BookoraThemeProvider` owns
// `data-theme` from mount onwards, and the inline script in `index.html` owns
// it before first paint. A third writer here would be the one that eventually
// disagrees with the AntD theme actually in force.
document.documentElement.lang = 'fa';
document.documentElement.dir = 'rtl';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
